<template>
  <div class="search-asylum-status">
    <header class="search-asylum-status__header">
      <af-h3>
        Arbetsstatus
      </af-h3>
    </header>

    <div class="search-asylum-status__read-more">
      <af-link href="/arbetsgivarinformation">
        <template slot="link">
          Läs mer om att anställa personer som är nya i Sverige
        </template>
      </af-link>
    </div>

    <section>
      <div class="search-asylum-status__box">
        <div class="search-asylum-status__box-frame">
          <af-checkbox
            :checked="hasResidencePermitChecked"
            name="hasResidencePermit"
            @changed="hasResidencePermit">
            Personer med uppehållstillstånd</af-checkbox>
        </div>
        <div class="search-asylum-status__box-content">
          <p>En person med uppehållstillstånd kan anställas precis som vanligt. Det finns inga speciella regler eller krav du behöver förhålla dig till som arbetsgivare. I vissa fall kan du få ekonomiskt stöd när du anställer nyanlända personer.</p>
        </div>
      </div>

      <div class="search-asylum-status__box">
        <div class="search-asylum-status__box-frame">
          <af-checkbox
            :checked="hasWorkPermitChecked"
            name="hasAtUnd"
            @changed="hasWorkPermit">
            Personer som <strong>får</strong> jobba</af-checkbox>
        </div>
        <div class="search-asylum-status__box-content">
          <p>
            En person får jobba i Sverige om personen har ett bevis om AT-UND <em>(undantag från kravet på arbetstillstånd)</em> på sitt LMA-kort.
          </p>
        </div>
      </div>

      <div class="search-asylum-status__box">
        <div class="search-asylum-status__box-frame">
          <af-checkbox
            :checked="noWorkPermitChecked"
            name="seekingAsylum"
            @changed="noWorkPermit">
            Personer som <strong>inte får</strong> jobba än</af-checkbox>
        </div>
        <div class="search-asylum-status__box-content">
          <p>
            En person som ännu inte har fått ett bevis om AT-UND <em>(undantag från kravet på arbetstillstånd)</em> på sitt LMA-kort får inte jobba i Sverige.
          </p>
          <br />
          <p>
            Vill du anställa en person som ännu inte fått bevis AT-UND? Be personen kontakta Migrationsverket för att fråga om hen kommer att få AT-UND.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  HAS_RESIDENCE_PERMIT,
  HAS_WORK_PERMIT,
  NO_WORK_PERMIT,
  REMOVE_FROM_QUERY
} from '@/store/actionTypes'
import AfCheckbox from '@/components/AfCheckbox'
import AfH3 from '@/components/AfH3'
import AfH4 from '@/components/AfH4'
import AfLink from '@/components/AfLink'
import Icon from '@/components/Icon'

export default {
  name: 'SearchAsylumStatus',

  components: {
    AfCheckbox,
    AfH3,
    AfH4,
    AfLink,
    Icon
  },

  computed: {
    ...mapGetters([
      'hasWorkPermitChecked',
      'hasResidencePermitChecked',
      'noWorkPermitChecked'
    ])
  },

  methods: {
    hasResidencePermit(_, checked) {
      if (!checked) {
        this.$store.commit(REMOVE_FROM_QUERY, {
          type: 'asylumStatus',
          path: 'hasResidencePermit',
          value: true
        })
      } else {
        this.$store.commit(HAS_RESIDENCE_PERMIT)
      }
    },

    hasWorkPermit(_, checked) {
      if (!checked) {
        this.$store.commit(REMOVE_FROM_QUERY, {
          type: 'asylumStatus',
          path: 'hasAtUnd',
          value: true
        })
      } else {
        this.$store.commit(HAS_WORK_PERMIT)
      }
    },

    noWorkPermit(_, checked) {
      if (!checked) {
        this.$store.commit(REMOVE_FROM_QUERY, {
          type: 'asylumStatus',
          path: 'hasAtUnd',
          value: false
        })
      } else {
        this.$store.commit(NO_WORK_PERMIT)
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-asylum-status {
  background-color: var(--color-white);
  padding: var(--spacing) var(--spacing-medium);

  @media (--bp-desktop) {
    & section {
      display: flex;
      justify-content: space-between;
    }
  }
}

.search-asylum-status__header {
  align-items: center;
  display: flex;
  margin-bottom: var(--spacing-third);
}

.search-asylum-status__read-more {
  margin-bottom: var(--spacing-medium);
}

.search-asylum-status__box {
  &:not(:last-child) {
    margin-bottom: 10px;
  }

  @media (--bp-desktop) {
    background: var(--color-porcelain);
    padding: var(--spacing-half);
    width: 32.25%;

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }

  @media (--bp-large) {
    width: 100%;
  }

  @media (--bp-desktop) {
    width: 32.25%;
  }
  & header {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
  }
}

.icon {
  margin-right: var(--spacing-half);
}

p {
  margin: 0;
}

.search-asylum-status__box-frame {
  background: var(--color-white);
  border: 1px solid var(--color-iron);
  border-radius: 5px;
  padding: var(--spacing-third);

  @media (--bp-desktop) {
    padding: var(--spacing-medium);
  }
}

.search-asylum-status__box-content {
  display: none;
  padding: var(--spacing-third);

  @media (--bp-desktop) {
    display: block;
  }
}

.search-asylum-status__box-content p {
  font-size: 16px !important;
  line-height: 24px !important;
}

h3 {
  font-weight: 600;
}

h4 {
  margin: var(--spacing-half) 0 !important;
}

.search-asylum-status__footer {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchAsylumStatus.vue